import React, { useState, useEffect } from 'react';
import './LoadingSpinner.css';

/**
 * Mostra uno spinner di caricamento a schermo intero con un overlay.
 * Gestisce un'animazione di fade-out prima di scomparire.
 * @param {boolean} show - Se true, mostra lo spinner. Se diventa false, avvia il fade-out.
 */
const LoadingSpinner = ({ show }) => {
  // Stato per controllare se il componente è montato nel DOM
  const [isMounted, setIsMounted] = useState(show);
  // Stato per controllare la classe 'hiding' per l'animazione di fade-out
  const [isHiding, setIsHiding] = useState(false);

  useEffect(() => {
    if (show) {
      // Se show è true, assicurati che sia montato e non stia scomparendo
      setIsMounted(true);
      setIsHiding(false);
    } else {
      // Se show diventa false, avvia l'animazione di scomparsa
      setIsHiding(true);
      // Imposta un timer per rimuovere il componente dal DOM dopo la fine dell'animazione
      const timer = setTimeout(() => {
        setIsMounted(false);
      }, 500); // Deve corrispondere alla durata della transizione in CSS (0.5s)

      // Cleanup del timer
      return () => clearTimeout(timer);
    }
  }, [show]); // Questo effetto si attiva ogni volta che la prop 'show' cambia

  // Non renderizzare nulla se il componente non è montato
  if (!isMounted) {
    return null;
  }

  // Applica la classe 'hiding' per avviare il fade-out
  return (
    <div className={`spinner-overlay ${isHiding ? 'hiding' : ''}`}>
      <div className="spinner-container"></div>
    </div>
  );
};

export default LoadingSpinner;